import { _debugMode, _maxPlaySoundCallsPer5Seconds, _soundPrefix } from "./constants";
import sizeof from "object-sizeof";
import { rateLimit, updict } from "./foo";
import { useTts } from "tts-react";
import { label2LabelToShow } from "../foo/cards";

/* VARIABLES */
let isPlayingAudio = false;

export interface Sound {
    base64: string;
    mimeType: string;
}

export function stopRecording(recorder: MediaRecorder) {
  if (recorder.state === 'recording') {
    recorder.stop();
  }
}

export const rateLimitedPlaySound = rateLimit(playSound, _maxPlaySoundCallsPer5Seconds, 5*1000);


export async function playSound(sound:Sound){
  if (isPlayingAudio) return;
    if(sound != null){
      if(_debugMode){console.log("Playing sound",sound);}
      if(_debugMode){console.log("Size of recorded audio:",sizeof(sound),"Bytes");}
      if(_debugMode){console.log("Size of uncompressed recorded audio:",sizeof(sound.base64),"Bytes");}
      const audioRef = new Audio(`data:${sound.mimeType};base64,${sound.base64}`)
      audioRef.oncanplaythrough = () => {
        isPlayingAudio = true;
        audioRef.play();        
      }
      audioRef.onended = () => {
        isPlayingAudio = false;
      };
      audioRef.load()
    }
}


export async function convertBlobToSound(blob: Blob): Promise<Sound> {
  const buffer = await blob.arrayBuffer();
  const base64 = btoa(String.fromCharCode(...new Uint8Array(buffer)));
  const mimeType = blob.type;
  return { base64, mimeType };
}

/*
export function storeSound(sound:Sound, fileName:string){
    Preferences.set({ key: _soundPrefix+slugify(fileName), value: JSON.stringify(sound) });
}


export async function loadSound(label:string){
    const { value } = await Preferences.get({ key: _soundPrefix+slugify(label) });
    let sound = (value ? JSON.parse(value) : null) as Sound;
    return sound
}*/

/*
export async function record(doRecord:boolean): Promise<Sound | undefined> {
  let hasPermission = true;
  let sound: Sound | undefined;
  const isRecording = (await VoiceRecorder.getCurrentStatus()).status === 'RECORDING';


  try {
    hasPermission = (await VoiceRecorder.hasAudioRecordingPermission()).value;
  } catch (error) {
    if (!(error as Error).message.includes("COULD_NOT_QUERY_PERMISSION_STATUS")) {
      hasPermission = false;
    }
  }
  if(!hasPermission) {
    try{
      hasPermission = (await VoiceRecorder.requestAudioRecordingPermission()).value;
    }catch(error){
      if(_debugMode){console.log(error)}
      hasPermission = true;
    }
    
  }
  if(hasPermission){
    if(doRecord && !isRecording){
      VoiceRecorder.startRecording();
      setTimeout(() => {
        VoiceRecorder.stopRecording();
      }, 5000);
    
    }
    else if(!doRecord && isRecording){
      const response = await VoiceRecorder.stopRecording();
      sound = { "base64": response.value.recordDataBase64,
                "mimeType": response.value.mimeType } as Sound;
    }
  }
  return sound;
}*/



export async function record(setTimeoutId: any, setDoRecord: any): Promise<{ data: Promise<{ base64: string; mimeType: string }>; recorder_: MediaRecorder }> {
  const constraints = { audio: true };
  try {
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    const tracks = stream.getAudioTracks();
    setTimeoutId(setTimeout(() => {
      tracks.forEach(track => track.stop());
      setDoRecord(false);
    }, 4000));

    const recorder_ = new MediaRecorder(stream);
    const chunks: Blob[] = [];
    recorder_.ondataavailable = e => chunks.push(e.data);
    recorder_.start();

    const dataPromise = new Promise<{ base64: string; mimeType: string }>(resolve => {
      recorder_.onstop = async () => {
        const blob = new Blob(chunks, { type: recorder_.mimeType });
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const dataUrl = reader.result as string;
          const base64 = dataUrl.split(',')[1];
          resolve({
            base64,
            mimeType: recorder_.mimeType
          });
        };
      };
    });

    return { data: dataPromise, recorder_ };
  } catch (err) {
    console.error(err);
    throw err;
  }
}



/**
 * Plays the sounds associated with each label in the sentence array in sequence.
 * @param {string[]} sentence - An array of strings representing the labels in the sentence.
 * @param {Object} l2audio - An object containing the sounds associated with each label.
 */
export async function readSentence(sentence: string[], l2audio: any) {
  if (isPlayingAudio) return;
  isPlayingAudio = true;
  for (const label of sentence) {
    if (label in l2audio){
      await new Promise(resolve => {
        const audioRef = new Audio(`data:${l2audio[label].mimeType};base64,${l2audio[label].base64}`);
        audioRef.onended = resolve;
        audioRef.play();
      });
    }
  }
  isPlayingAudio = false;
}



export const callRecord = async function (
  doRecord:boolean,
  setDoRecord:any,
  l2audio:any,
  label:string,
  setL2Audio:any,
  recorder:any,
  setRecorder:any,
  setTimeoutId: any,
  timeoutId: any
  ){

  
  if(doRecord == true){
    stopRecording(recorder);
    setDoRecord(false);
    clearTimeout(timeoutId);
  }else{
    setTimeout(() => {
      setDoRecord(true);
    }, 500);
    const { data, recorder_ } = await record(setTimeoutId, setDoRecord);
    setRecorder(recorder_);

    let snd = await data;
    if(snd != undefined){
      let newL2Audio = updict(l2audio, label, snd);
      setL2Audio(newL2Audio);
      return true;    
    }
    return false;
  }
}


export function getTTSOptions(lang:string, label:string | string[]){
  // If label is a string put it in an array
  if(typeof label === "string"){ label = [label]; }

  label = label.map((label) => {
    return label2LabelToShow(label, lang);
  });
  
  let voices, chosenVoice, chosenLang, ttsOptions;
  voices = speechSynthesis.getVoices();
  if(lang == "it"){ chosenVoice = voices.find(voice => voice.name.includes("Microsoft Elsa - Italian")); chosenLang = "it-IT";}
  else if(lang == "de"){ chosenVoice = voices.find(voice => voice.name.includes("Microsoft Hedda - German")); chosenLang = "de-DE";}
  else{ chosenVoice = null; chosenLang = "en-EN";}
  if(chosenVoice === null){
    ttsOptions = {
      children: label,
      lang:chosenLang,
      markTextAsSpoken: true
    }
  }else{
    ttsOptions = {
      children: label,
      lang:chosenLang,
      voice:chosenVoice,
      markTextAsSpoken: true
    }
  }
 
  return ttsOptions;
}
